/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, TouchableHighlight, TouchableOpacity, Platform } from 'react-native'
import styles from './Styles/ListItemTextIconStyle'

import Svg, {
  Circle,
  Ellipse,
  G,
  LinearGradient,
  RadialGradient,
  Line,
  Path,
  Polygon,
  Polyline,
  Rect,
  Symbol,

  Use,
  Defs,
  Stop
} from 'react-native-svg';
import { Container, Icon, Header, Content, ListItem, CheckBox, Thumbnail, Text, Left, Body, Right, Separator } from 'native-base';
import { SvgDonate } from './SvgComponent'
export default class ListItemTextIcon extends Component {


  render() {
    const { backgroundColor = '#FFFFFF' } = this.props
    const { borderBottomWidth = 0.5 } = this.props
    const { extraTextStyle = {} } = this.props

    let forNative = Platform.OS != 'web' ? (<Content>
      <ListItem button disabled = {this.props.disabled} onPress={this.props.onCellPress} style={{
        height: 44
        , marginLeft: 0,
        backgroundColor: this.props.backgroundColor,
        borderBottomWidth: borderBottomWidth,
        flex: 1,
        justifyContent: 'space-between'
      }} >
        <Text style={[styles.textStyle, extraTextStyle]}>{this.props.text}</Text>
        <View>

        </View>
        <Right style={{ paddingRight: -5 }}>
          {this.props.children}
        </Right>
      </ListItem>
    </Content>) : null

    // bizarre run time problems w/ native-base on web, try just normal elements
    let forWeb = (
      <View style={{width: '100%'}}>
        <Text onPress={!this.props.disabled ? this.props.onCellPress : ()=>{} } style={{
            height: 44
            , marginLeft: 0,
            backgroundColor: this.props.backgroundColor,
            borderBottomWidth: borderBottomWidth,
            flex: 1,
            justifyContent: 'space-between'
        }}>
           <Text style={[styles.textStyle, extraTextStyle]}>{this.props.text}</Text>

           <View>

           </View>

           <View style={{ paddingRight: -5, position: 'absolute', right: 20 }}>
             {this.props.children}
           </View>

      </Text>

      </View>
    )

    return (Platform.OS == 'web' ? forWeb : forNative)
  

  }
}
